<template>
    <div class="searchable-dropdown">
        <div class="input-area">
            <custom-input 
                class="searchinput" 
                :class="{'inactive' : !selectedElement && inputValue, 'valid-input' : inputIsValid}"
                v-if="!selectedElement" 
                v-model.trim="inputValue" 
                @input="searchDebounce(inputValue)"
                :inputType="'text'" 
                :name="name" 
                :label="$t('country-search.country')" 
                :placeholder="$t('country-search.search')" 
                :autoComplete="'disabled'" 
                :focusInputField="focusInputField" 
                :invalidInput="invalidInput"
            />
                <!-- :invalidInput="inputCheck ||  invalidInput" -->
                <!-- :invalidInput="invalidInput || (!selectedElement && inputValue && !inputIsValid)" -->
            
            <div v-else @click="reset(selectedElement)" class="selected-info">
                <custom-input 
                    :inputType="'text'" 
                    v-model="selectedValue" 
                    :name="'dropdown-value'" 
                    :label="'Country'" 
                    :placeholder="'Search country'" 
                />
                <span class="additional-country-info">{{selectedElement.name}}</span>
            </div>
            <i class="fa-light fa-chevron-down chevron"></i>
        </div>
        
        <div class="dropdown-list custom-scrollbar-light" v-show="inputValue && !selectedElement">
            <div v-show="searching" class="searching"><i class="fa-light fa-circle-notch fa-spin"></i></div>
            <div v-if="searchError" class="search-error">{{$t('country-search.no-result')}}</div>
            <div v-if="!searching && !searchError">
                
                <div v-for="(element, index) in countries" :key="index" class="element" @click="selectCountry(element)">
                    <img class="flag" :src="element.flag" :alt="element.name">
                    <input type="text" :name="element.name" :value="element.name" readonly class="element-input" v-on:keyup.enter="selectCountry(element)" contenteditable="false">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CustomInput from "@/components/CustomInput";
import debounce from 'lodash/debounce'
  export default {
    name: 'CountrySearch',
    data(){
      return{
          selectedElement: null,
          inputValue: this.startingValue,
          countries: [],
          searching: false,
          searchDebounce: debounce((filter) => {
                this.searching = true
                this.searchError = false
                if (filter.length) this.searchCountry(filter)
                else { 
                    this.countries = []
                    this.searching = false
                }
            }, 500),
            focusInputField: null,
            searchError: false,
            oldSelection: null,
            inputIsValid: false
      }
    },
    props: {
        startingValue: {
            type: String,
            default: ''
            },
        selectedValue: {
            type: String
        },
        invalidInput: {
            type: Boolean
        },
        name: {
            type: String
        }
    },
    methods:{
        onBlurInput(){
            console.log(event)
            this.selectedElement = this.oldSelection 
        },
        searchCountry(){
            this.searchError = false
            this.searching = true
            this.$store.dispatch('getCountry', this.inputValue).then((res) => {
                this.countries = res
                this.searching = false
            }).catch((e) => {
                this.searching = false
                this.searchError = true
            })
        },
        reset(){
            this.searchCountry()
            this.inputValue = this.selectedElement.name
            this.oldSelection = this.selectedElement
            this.selectedElement = null
            this.$emit('on-element-reset')
            this.focusInputField = true
        },
        selectCountry(element){
            this.selectedElement = element
            this.$emit('on-element-selected', this.selectedElement.cca2)
        }
    },
    computed:{
        inputCheck(){
            return !this.inputIsValid && this.inputValue.length && !this.selectedElement
        }
    },
    watch: {
        inputValue:{
            handler: function (val, oldVal) {
               if( !this.selectedElement && this.$store.state.validCountryCodes.includes(this.inputValue.toUpperCase())  ){
                    console.log("Its valid")
                    this.inputIsValid = true
                    this.$emit('on-element-selected', this.inputValue.toUpperCase())
               } else {
                   console.log("its invalid")
                   this.inputIsValid = false
                   this.$emit('on-element-reset')
                   
               }
            }
        }
    },
    components:{
        CustomInput
    }

}

</script>

<style lang="less">
.searchable-dropdown{
    position: relative;
    .input-area{
        position: relative;
        .chevron{
            position: absolute;
            top: 46px;
            right: 4px;
            opacity: .4;

        }
    }
    .searching, .search-error{
        padding: 4px 12px;
    }
    .element{
        padding: 4px 12px;
        &:hover, &:focus-within{
            cursor: pointer;
            background: #d6d9db;
        }
        .element-input{
            cursor: pointer;    
            pointer-events: none;
            outline: none;
            border: none;
            // opacity: 0;
            // width: 10px;
            :focus{
                -webkit-touch-callout: none; /* iOS Safari */
                -webkit-user-select: none; /* Safari */
                -khtml-user-select: none; /* Konqueror HTML */
                -moz-user-select: none; /* Old versions of Firefox */
                -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none;
            }
            &::selection{
                background: none;
            }
            &::-moz-selection{
                background: none;
            }
        }
    }
    .dropdown-list{
        position: absolute;
        z-index: 99;
        width: 100%;
        max-height: 250px;
        margin-top: 4px;
        overflow-y: auto;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        background: #ffffff;
        opacity: 0;
        pointer-events: none;

        .flag{
            width: 12px;
            margin-right: 12px;
        }
    }
    &:focus-within {
        .dropdown-list{
            transition: .2s;
            opacity: 1;
            pointer-events: auto;
        }
    }
        .dropdown-list:hover{
            transition: .2s;
            opacity: 1;
            pointer-events: auto;
        }

    .selected-info{
        position: relative;
        .additional-country-info{
            position: absolute;
            opacity: .4;
            right: 22px;
            top: 42px;
        }
    }
    .searchinput.inactive:not(:focus-within):not(.valid-input){
        input{
            // padding-right: 25px;
            // opacity: 0.4;
        }
    }
    .searchinput.valid-input{
        opacity: 1;
    }
    
}
</style>

